class ProductType {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`products.type.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(productType) {
        return productType === this;
    }
}

export const SECURITY = new ProductType('SECURITY');
export const ENERGY = new ProductType('ENERGY');
export const UNKNOWN = new ProductType('null');

export const getProductType = (serverType) => {
    let result;
    switch (serverType) {
        case 'SECURITY':
            result = SECURITY;
            break;
        case 'ENERGY':
            result = ENERGY;
            break;
        default:
            result = UNKNOWN;
    }
    return result;
};

export const getAllProductTypes = () => [
    SECURITY,
    ENERGY,
];
